import type { ChangelogEntry } from "../types";

/**
 * Hjelp og Rapporter fyller nå hele innholdsflata.
 *
 * Hjelp-punktet står uten rollekrav fordi hjelp-senteret er åpent for alle
 * roller, eksterne inkludert. Rapporter-punktet har `minRole: "admin"`:
 * `role_menu_permissions` gir bare admin og superadmin `rapporter`, så et punkt
 * uten rollekrav ville fortalt ansatte om en side de ikke kan åpne.
 */
export const FULL_BREDDE_2026_10: ChangelogEntry = {
  id: "2026-10-05-full-bredde",
  date: "2026-10-05",
  title: "Hjelp og Rapporter bruker hele skjermen",
  summary:
    "Begge sidene lå sentrert i en smal spalte med tomme marger på hver side. Nå fyller de innholdsflata, som resten av Revehiet.",
  sections: [
    {
      heading: "Hjelp",
      items: [
        {
          title: "Hjelp fyller hele flata",
          kind: "forbedret",
          body: "Veiledningen lå i en spalte midt på skjermen med luft på begge sider, uansett hvor stor skjermen var. Nå starter innholdet der menyen slutter og går helt ut. Skjermbildene vokser ikke med: de beholder bredden de hadde, siden et bilde bare blir uskarpt av å strekkes forbi sin egen størrelse.",
        },
        {
          title: "Flere temakort ved siden av hverandre",
          kind: "forbedret",
          body: "Kortene på hjelp-oversikten sto to i bredden uansett skjerm. På en stor skjerm får du nå tre eller fire, så du ser flere temaer uten å rulle.",
        },
      ],
    },
    {
      heading: "Rapporter",
      minRole: "admin",
      items: [
        {
          title: "Rapporttabellene får hele bredden",
          kind: "forbedret",
          body: "Rapportsiden var låst til samme smale spalte som Hjelp, så brede tabeller måtte presse kolonnene sammen mens det sto ubrukt plass på hver side. Nå bruker tabellen skjermen du faktisk har.",
        },
      ],
    },
  ],
};
